import { useState, useEffect } from 'react';
import { isNativeApp } from '../utils/platform';
import { getPlatformSettings } from '../utils/api';

// Compare dotted versions: returns 1 if a > b, -1 if a < b, 0 if equal.
function cmpVer(a, b) {
  const pa = String(a).split('.').map(n => parseInt(n, 10) || 0);
  const pb = String(b).split('.').map(n => parseInt(n, 10) || 0);
  for (let i = 0; i < Math.max(pa.length, pb.length); i++) {
    const d = (pa[i] || 0) - (pb[i] || 0);
    if (d) return d > 0 ? 1 : -1;
  }
  return 0;
}

// Shows an "update available" bar in the installed app when the admin has set a
// newer APK version than the one running. Android can't silently install a
// sideloaded APK, so this points the user to the download.
export default function UpdateBanner() {
  const [info, setInfo] = useState(null); // { version, url }
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (!isNativeApp()) return;
    (async () => {
      try {
        const { App } = await import('@capacitor/app');
        const cur = (await App.getInfo()).version;
        const s = await getPlatformSettings();
        if (s?.apkUrl && s?.apkVersion && cmpVer(s.apkVersion, cur) > 0 &&
            sessionStorage.getItem('tt_update_dismissed') !== s.apkVersion) {
          setInfo({ version: s.apkVersion, url: s.apkUrl });
        }
      } catch { /* @capacitor/app absent or offline — ignore */ }
    })();
  }, []);

  if (!info || dismissed) return null;
  const close = () => { sessionStorage.setItem('tt_update_dismissed', info.version); setDismissed(true); };

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 9997, background: 'linear-gradient(135deg,#0c1428,#1a2540)', color: '#fff', padding: '10px 14px', display: 'flex', alignItems: 'center', gap: 12, boxShadow: '0 2px 16px rgba(0,0,0,0.3)' }}>
      <div style={{ width: 34, height: 34, borderRadius: 9, background: 'var(--org)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, fontFamily: 'var(--display)', fontWeight: 900, fontSize: 17 }}>T</div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 13, fontWeight: 700 }}>Update available (v{info.version})</div>
        <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.6)' }}>Download the latest Toppers app.</div>
      </div>
      <a href={info.url} target="_blank" rel="noreferrer" style={{ flexShrink: 0, background: 'var(--org)', color: '#fff', textDecoration: 'none', fontSize: 12.5, fontWeight: 700, padding: '8px 14px', borderRadius: 8 }}>Update</a>
      <button onClick={close} style={{ flexShrink: 0, background: 'none', border: 'none', color: 'rgba(255,255,255,0.5)', cursor: 'pointer', fontSize: 18, lineHeight: 1, padding: 4 }}>×</button>
    </div>
  );
}
